import React, { useEffect } from "react";
import { connect } from "react-redux";
import {
  createCorral,
  deleteCorral,
  fetchFarmCorrals,
  fetchLivestockInfosFromCorrals,
  fetchFarmRetreats,
  updateCorral,
} from "redux/operations";
import { RootState } from "redux/reducers";
import CorralPage from "./corralPage";

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

type CauseOfDeathContainerProps = StateProps & DispatchProps;

function CorralContainer({
  createCorral,
  deleteCorral,
  farmCorrals,
  farmRetreats,
  fetchFarmCorrals,
  fetchFarmRetreats,
  fetchLivestockInfosFromCorrals,
  livestockInfosFromCorrals,
  updateCorral,
}: CauseOfDeathContainerProps) {
  useEffect(() => {
    const fetchData = async () => {
      // Make sure corrals are fetched before fetching livestock infos
      await Promise.resolve(fetchFarmCorrals());
      fetchFarmRetreats();
      fetchLivestockInfosFromCorrals();
    };

    fetchData();
    // We want to run this only once on component mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCreateCorral = async (
    ...params: Parameters<typeof createCorral>
  ) => {
    await Promise.resolve(createCorral(...params));
    // Ensure corral is created before refetching
    fetchFarmCorrals();
  };

  const handleUpdateCorral = async (
    ...params: Parameters<typeof updateCorral>
  ) => {
    await Promise.resolve(updateCorral(...params));
    // Ensure corral is updated before refetching
    fetchFarmCorrals();
  };

  const handleDeleteCorral = async (
    ...params: Parameters<typeof deleteCorral>
  ) => {
    await Promise.resolve(deleteCorral(...params));
    // Ensure corral is deleted before refetching
    fetchFarmCorrals();
  };

  return (
    <CorralPage
      farmCorrals={farmCorrals}
      createCorral={handleCreateCorral}
      deleteCorral={handleDeleteCorral}
      livestockInfosFromCorrals={livestockInfosFromCorrals}
      farmRetreats={farmRetreats}
      updateCorral={handleUpdateCorral}
    />
  );
}

const mapStateToProps = (state: RootState) => ({
  farmCorrals: state.pasture.farmCorrals,
  farmRetreats: state.pasture.farmRetreats,
  livestockInfosFromCorrals: state.livestock.infosFromCorrals,
});

const mapDispatchToProps = {
  createCorral,
  deleteCorral,
  fetchFarmCorrals,
  fetchFarmRetreats,
  fetchLivestockInfosFromCorrals,
  updateCorral,
};

export default connect(mapStateToProps, mapDispatchToProps)(CorralContainer);
